import { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import MobileCartSideBar from "../Components/MobileCartSideBar";
import { ConfigContext } from "../Context/ConfigContext";
import SearchBar from "../Components/SearchBar/SearchBar";
import { useTranslation } from "react-i18next";
import slugify from "slugify";
import MyGarage from "./MyGarage";
import MobileSearchBar from "../Components/SearchBar/MobileSearchBar";
import { CartsContext } from "../Context/CartsContext";
import FlyingGirl from "../Pages/Home/DiscountBanners/FlyingGirl";
import FloatingPromo from "../Pages/Home/DiscountBanners/FloatingPromo";
import DiscountBanner from "../Pages/Home/DiscountBanners/DiscountBanner";
import Config from "../appConfig";
import { axiosGet } from "../Apis/axiosMethods";

const Header = ({ openDrawer, isMobile }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dir = localStorage.getItem("dir");
  const {
    setSideBarStatus,
    setCategories,
    CartItemsQty,
    lang,
    setLang,
    isCartDropdownOpen,
    setIsCartDropdownOpen,
    FavItemsQty,
    marqueeRows
  } = useContext(ConfigContext);

  const [menuItems, setmenuItems] = useState({ paddingLeft: '18px', color: '#FFF', zIndex: '100000' });
  const [showTrainingModal, setShowTrainingModal] = useState(false);


  const { cartItems, sub_total_display } = useContext(CartsContext);
  const [postLoading, setPostLoading] = useState(false);

  const handleLangChange = (lang) => {
    localStorage.setItem("lang", lang);
    i18n.changeLanguage(lang);
    setLang(lang);
    window.location.reload();
  };

  const { currency, setCurrency } = useContext(ConfigContext);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const pc_id = localStorage.getItem("pc_id");

        const endpoint = pc_id !== null && pc_id !== "" && pc_id !== "0" ? "GetCategoriesByCar" : "GetCategories";
        const response = await axiosGet(`/Parts/${endpoint}`, { pc_id, lang });
        setCategories(response.data.data);

      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, [lang]);

  const GetSubMenu = ({ childrens }) => {
    if (childrens.length === 0) {
      return null; // No submenu to render
    }

    return (
      <ul className="submenu" style={dir === "rtl" ? { left: "unset", right: "100%" } : { left: "100%" }}>
        {childrens.map((child, index) => (
          <li key={`${child.STR_ID}-${index}`}>
            <NavLink
              to={`/Spare-Parts/${slugify(child.STR_NODE_NAME)}-${child.STR_ID
                }`}>
              {child.STR_NODE_NAME}{" "}
              {child.children.length > 0 && (
                <i
                  style={{ float: dir === "rtl" ? "left" : "right" }}
                  className={`fas ${dir === "rtl" ? "fa-chevron-left" : "fa-chevron-right"
                    }`}></i>
              )}
            </NavLink>
            {child.children.length > 0 && (
              <GetSubMenu childrens={child.children} />
            )}
          </li>
        ))}
      </ul>
    );
  };

  const hasDiscount = marqueeRows?.some(
    (sup) => sup?.sup_brand && Number(sup?.business_brand_discount || 0) > 0
  );

  const handleCurrencyChange = (newCurrency) => {
    setCurrency(newCurrency);
    window.location.reload();
  };


  const [showDiscountComponents, setShowDiscountComponents] = useState(false);

  useEffect(() => {
    const loadDiscountComponents = () => {
      setShowDiscountComponents(true);
    };

    if ("requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(loadDiscountComponents, { timeout: 1000 });
      return () => window.cancelIdleCallback(idleId);
    }

    const timeoutId = setTimeout(loadDiscountComponents, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      {showDiscountComponents && (
        <>
          <FlyingGirl />
          <FloatingPromo />
          <DiscountBanner />
        </>
      )}

      <header className="header prevent-select" dir={dir} style={{ textAlign: dir === 'rtl' ? 'right' : 'unset', }}>
        {
          marqueeRows?.length > 0 && hasDiscount &&
          <div className="header-top darkColor" style={{ color: "#FFF", paddingTop: '10px', height: '45px' }}>

            <div className="container" dir="ltr">
              <div className="header-left w-100">

                <div className="marquee-wrapper">
                  <div className="marquee-content">

                    {[...Array(2)].map((_, i) => (
                      <div className="marquee-track" key={i}>

                        <span className="marquee-text">
                          Special Discounts on Spare Parts from
                        </span>

                        {marqueeRows.map((sup, index) => {
                          if (!sup?.sup_brand || Number(sup.business_brand_discount) <= 0) return null;

                          return (
                            <span key={`${i}-${index}`} className="marquee-item">
                              <NavLink to={`/Spare-Parts/PartsByBrand/${sup.sup_id}-${sup.sup_brand}`}>
                                {sup.sup_brand} ({sup.business_brand_discount}%) OFF
                              </NavLink>
                            </span>
                          );
                        })}

                      </div>
                    ))}

                  </div>
                </div>

              </div>

              {/* ✅ Internal CSS */}
              <style>
                {`
          .marquee-wrapper {
            overflow: hidden;
          }

          .marquee-content {
            display: flex;
            width: max-content;
            animation: scrollLeft 18s linear infinite;
          }

          .marquee-content:hover {
            animation-play-state: paused;
          }

          .marquee-track {
            display: flex;
            align-items: center;
            white-space: nowrap;
          }

          .marquee-text {
            color: #fff;
            font-weight: 600;
            margin-right: 15px;
            font-size: 14px;
          }

          .marquee-item {
            margin: 0 15px;
          }

          @keyframes scrollLeft {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-50%); }
          }
        `}
              </style>
            </div>

          </div>
        }


        <div className="header-middle lightColor" style={{ borderTop: "0px", padding: '0', paddingTop: '12px', display: isMobile ? 'none' : 'block' }}>
          <div className="container">

            <div className="header-left col-sm-3 w-auto pl-0 pd-1">

            </div>
            {/* End .header-left */}

            <div className="header-right w-lg-max">
              <div
                style={{
                  direction: dir,
                  width: '530px',
                  cursor: "pointer"
                }}
                className="header-icon header-search header-search-inline header-search-category mt-0">
                <img
                  src={`${Config.country === "uae" ? "/assets/images/Logo/car7_transparent_powered_by.png" : Config.country === "ksa" ? "/assets/images/Logo/ghayar_alemtiyaz.png" : "/assets/images/Logo/car7_transparent_powered_by.png"}`}
                  style={{
                    height: Config.country === "ksa" ? '100px' : "63px",
                    margin: 'auto'
                  }}
                  onClick={() => window.location = '/'}
                  alt="Ghayar Logo"
                />

              </div>
              {/* End .header-search */}

              <div className="darkColor pl-3 pr-3 pt-1 pb-1"
                style={{ display: "flex", alignItems: "center", right: '15px', position: 'absolute' }}>

                {isMobile === false && <span className="header-icon" style={{ display: "flex", alignItems: "flex-start", marginRight: "20px", cursor: "pointer", }}  >

                  {/* <div className="header-dropdown position-relative">

                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        cursor: "pointer",
                        color: "rgb(191, 203, 210)",
                        marginRight: "10px"
                      }}
                    >
                      <i className="fas fa-coins"></i>
                      {currency?.toUpperCase()}
                      <i className="fas fa-chevron-down" style={{ fontSize: "10px" }}></i>
                    </div>

                    <div className="header-menu">
                      <ul>
                        <li>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleCurrencyChange(
                                Config.country === "ksa" ? "SAR" : "AED"
                              );
                            }}
                          >
                            {Config.country === "ksa" ? "SAR" : "AED"}
                          </a>
                        </li>

                        <li>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleCurrencyChange("usd");
                            }}
                          >
                            USD
                          </a>
                        </li>
                      </ul>
                    </div>

                  </div> */}

                  <svg
                    className="header-nav__icon base-svg mr-2"
                    role="img"
                    style={{
                      width: "30px",
                      height: "30px",
                      fill: "rgb(191, 203, 210)",

                    }}>
                    <use href="/assets/images/icon-sprite-bw.svg#sprite-garage-car-icon-bw"></use>
                  </svg>
                  <div
                    style={{ color: "rgb(191, 203, 210)", marginLeft: '10px', marginTop: '-5px' }}
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-p="true"
                    aria-expanded="false">
                    <div style={{ fontSize: "medium", fontWeight: "600", paddingRight: dir === 'rtl' ? '5px' : '', }}>
                      {t("my_cars")}
                    </div>
                    <div style={{ fontSize: "12px", paddingRight: dir === 'rtl' ? '5px' : '' }}>
                      {t("add_your_car")}
                    </div>
                  </div>

                  <MyGarage />
                </span>}

                {isMobile === false && <span className="header-icon" title="Garage" style={{ display: "flex", alignItems: "flex-start", marginRight: "20px", cursor: "pointer", }}  >
                  <i className="icon-user-2" style={{ color: "#bfcbd2" }}></i>
                  <div
                    style={{ color: "rgb(191, 203, 210)", marginLeft: '10px' }}
                    onClick={() => {
                      if (localStorage.getItem('business_id')) {
                        navigate('/MyAccount')
                      } else {
                        window.location = '/login'
                      }

                    }}
                  >
                    <div style={{ fontSize: "medium", fontWeight: "600", paddingRight: dir === 'rtl' ? '5px' : '' }}>
                      {t('my_ghayar')}
                    </div>
                    <div style={{ fontSize: "12px", marginTop: "-5px", paddingRight: dir === 'rtl' ? '5px' : '' }}>
                      {localStorage.getItem('business_id') ? t('my_account') : t('sign_in')}
                    </div>
                  </div>
                </span>}


              </div>


              {/* End .dropdown */}
            </div>
            {/* End .header-right */}
          </div>
          {/* End .container */}
        </div>
        <div className="header-middle lightColor" style={{ borderTop: "0px", paddingBottom: '12px' }}>
          <div className="container">
            <div className="header-right w-lg-max">
              <div style={{
                position: 'absolute',
                left: '0',
                right: '0',
                margin: '0 auto',
                width: 'fit-content',
              }}>

              </div>
              {isMobile &&
                <div onClick={() => window.location = '/basket'} style={{ marginTop: '10px', marginLeft: dir === 'rtl' ? '10px' : '', position: 'absolute', left: dir === 'rtl' ? '12px' : '' }}>
                  <img src="/assets/images/Logo/basket.png" alt="" />
                  <span
                    className="cart-count badge-circle"
                    style={dir === 'rtl' ? { marginTop: "-10px", position: 'absolute', right: '-5px' } : { marginTop: "4px", position: 'absolute', left: '12px', top: '-10px' }}>
                    {CartItemsQty}
                  </span>
                </div>
              }
              {/* End .header-search */}
              <div className="header-middle lightColor" style={{ borderTop: "0px", paddingBottom: '12px', width: '250px', marginRight: '15px' }}>
                <div className="container">

                  <div
                    className="header-left col-sm-12 w-auto pl-0 pd-1 mr-4"
                    style={{ cursor: 'pointer', backgroundColor: '#0e1f2a' }}
                    onClick={() => setSideBarStatus(true)}
                  >

                    <button
                      className="mobile-menu-toggler text-primary mr-2"
                      onClick={() => openDrawer()}
                      style={{ zIndex: 1000000000 }}

                      type="button">
                      <i className="fas fa-bars" />
                    </button>
                    <span
                      className=""
                      onClick={() => setSideBarStatus(true)}
                      style={menuItems}
                    >
                      <label
                        style={{
                          color: "rgb(191, 203, 210)",
                          marginTop: '6px',
                          fontWeight: 700,
                          fontSize: "14px",
                        }}
                        htmlFor="sidebar-toggle"
                        className="main-nav navbar-toggler sidebar-toggler"
                        aria-expanded="false"
                        aria-label="Toggle navigation">
                        <svg
                          className="header-nav__icon base-svg mr-2"
                          role="img"
                          style={{
                            width: "25px",
                            height: "25px",
                            fill: "rgb(208, 213, 215)",
                            marginLeft: dir === 'rtl' ? '10px' : ''
                          }}>
                          <use href="/assets/images/icon-sprite-bw.svg#sprite-car-icon-full-bw"></use>
                        </svg>
                        {t("car_parts")}
                        <i className="fas fa-chevron-down ml-2" style={{ fontSize: '12px', position: 'absolute', [dir === 'rtl' ? 'left' : 'right']: '15px', marginTop: '6px' }}></i>
                      </label>
                    </span>
                  </div>
                </div>
              </div>

              <SearchBar />
              {/* End .header-search */}

              <div tabIndex={0} className="darkColor pl-3 pr-3 pt-1 pb-1 cart-box-header no-select" onClick={() => window.location = "/basket"}
                style={{ display: "flex", alignItems: "center", right: '15px', position: 'absolute', width: '355px', justifyContent: 'space-between' }}

                onMouseEnter={() => setIsCartDropdownOpen(true)}
                onMouseLeave={() => setIsCartDropdownOpen(false)}>

                {isMobile === false && <span className="header-icon" title="Garage" style={{ display: "flex", alignItems: "center", marginRight: "20px", cursor: "pointer" }}  >
                  <div style={{ marginTop: '10px', marginLeft: dir === 'rtl' ? '10px' : '', position: 'relative' }}>
                    <img src="/assets/images/Logo/basket.png" alt="" style={{
                      height: "30px"
                    }} />
                    <span
                      className="text-primary"
                      style={{ marginTop: "4px", position: 'absolute', left: '17px', top: '-10px', fontSize: "18px", fontWeight: "bold" }}>
                      {cartItems?.length}
                    </span>
                  </div>
                  <div
                    style={{ color: "rgb(191, 203, 210)", }}
                  >
                    <div style={{ fontSize: "medium", fontWeight: "600", marginTop: "15px" }}>
                      Cart
                    </div>
                  </div>

                </span>}

                {isMobile === false &&
                  <div to="/basket" style={{ position: "relative", display: "inline-block" }} >
                    <div
                      className="mr-3"
                      style={{
                        color: "rgb(229 8 19)",
                        fontSize: "28px",
                        fontFamily: "Montserrat,Arial,sans-serif",
                      }}
                    >
                      {sub_total_display} <i className="fas fa-chevron-down" style={{ fontSize: '12px', verticalAlign: 'middle', marginLeft: '5px', color: '#afbac2' }}></i>
                    </div>
                    {isCartDropdownOpen && (
                      <div className="dropdown-content" style={{ position: "absolute", background: "#fff", border: "1px solid #ccc", zIndex: 100000000000, width: '400px', padding: '20px', marginLeft: dir !== 'rtl' ? '-200px' : 'unset', marginRight: dir === 'rtl' ? '-230px' : 'unset' }}>

                        {
                          !cartItems || cartItems?.length === 0 ? <div onClick={() => window.location = "/basket"} style={{ textAlign: 'center', }}>
                            <h4 style={{ color: '#666' }}>Your basket is empty</h4>
                          </div> : <div></div>
                        }

                        <p>{cartItems?.map((item) => {
                          return <table style={{ width: '100%' }}>
                            <tr>
                              <td style={{ width: '70px', minWidth: '70px' }} rowSpan={2}><img src={item.item_img_url} style={{ width: '70px', minWidth: '70px' }} alt={item.item_title} /></td>
                              <td style={{ color: '#000', }} className="pl-2 pr-2"><b>{" "} {item.item_title}</b></td>
                              {
                                item?.part_available === false &&
                                <td>
                                  <span
                                    className="badge"
                                    style={{
                                      padding: "16px", fontSize: "16px",
                                      background: "#ffdddd",
                                      color: "#d60000",
                                      borderRadius: "8px",
                                      fontWeight: "700",
                                      border: "1px dashed #ffb3b3"
                                    }}
                                  >
                                    Out of stock
                                  </span>
                                </td>
                              }
                            </tr>
                            <tr>
                              <td style={{ color: '#999', width: '200px' }} className="pl-2 pr-2">{" "} {t('qty')} x {item.item_qty}</td>
                              <td>{item.display_price}</td>
                            </tr>


                          </table>
                        })}</p>

                        <hr className="mt-2" style={{ margin: 'unset' }} />
                        {cartItems?.length > 0 && <table className="table table-totals mb-0">
                          <tbody>
                            <tr style={{ border: "none", marginBottom: "0px" }}>
                              <td style={{ textAlign: dir === 'rtl' ? 'right' : 'left', }}>{t("sub_total")}</td>
                              <td style={{ textAlign: dir !== 'rtl' ? 'right' : 'left', }} className="custom-dark">
                                <span>{sub_total_display}</span> <br />
                                {/* <small>{t('price_included_vat_excluded_delivery')}</small> */}
                                <small>Offer price excl. 5.0% VAT, Free delivery</small>
                              </td>
                            </tr>
                          </tbody>
                        </table>}

                        {cartItems?.length > 0 && <div className="checkout-methods">
                          <span
                            onClick={() => window.location = "/basket"
                            }
                            className="btn btn-block btn-dark"
                          >
                            {t("proceed_to_checkout")}
                            <i className="fa fa-arrow-right" />
                          </span>
                          <br />

                          <center>

                            <span

                              onClick={() => window.location = `/basket`}

                              className="mt-5" style={{ fontSize: '22px', color: '#003e94', cursor: 'pointer' }}
                            >

                              {t("go_to_basket")}

                            </span>
                          </center>
                        </div>}
                      </div>
                    )}
                  </div>}


              </div>

              <div className={`dropdown cart-dropdown show`}>
                <MobileCartSideBar />
              </div>
              {/* End .dropdown */}
            </div>
          </div>

          {/* End .container */}
        </div>
        {
          isMobile && <MobileSearchBar />
        }
        {/* End .header-middle */}
        <div
          className="header-bottom  d-none d-lg-block darkColor"
          style={{
            borderBottom: "1px solid rgb(226, 226, 226)",
            marginBottom: "10px",
          }}>
          <div className="container">
            <nav
              className="main-nav w-100"
              style={{
                display: 'flex',
                justifyContent: 'left'
              }}>
              <ul className="menu" style={{
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'left',
                margin: 0,
                padding: 0,
                float: 'none'
              }}>






                <li className="menuItemStyle"
                  style={dir === "rtl" ? {
                    float: "right",
                    marginRight: "20px"
                  }
                    :
                    {
                      float: "left"
                    }}
                >
                  <NavLink
                    to="/Spare-Parts/Spare-Parts-nocar/100354/CompressorParts"
                    style={{ color: "#bfcbd2" }}
                  >
                    <svg
                      style={{
                        fontSize: "16px",
                        marginRight: dir === 'rtl' ? '0' : '7px',
                        marginLeft: dir === 'rtl' ? '7px' : '0',
                        verticalAlign: 'middle', marginTop: '-5px'
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-snow3"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 7.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1" />
                      <path d="M8 16a.5.5 0 0 1-.5-.5v-1.293l-.646.647a.5.5 0 0 1-.707-.708L7.5 12.793v-1.51l-2.053-1.232-1.348.778-.495 1.85a.5.5 0 1 1-.966-.26l.237-.882-1.12.646a.5.5 0 0 1-.5-.866l1.12-.646-.883-.237a.5.5 0 1 1 .258-.966l1.85.495L5 9.155v-2.31l-1.4-.808-1.85.495a.5.5 0 1 1-.259-.966l.884-.237-1.12-.646a.5.5 0 0 1 .5-.866l1.12.646-.237-.883a.5.5 0 1 1 .966-.258l.495 1.849 1.348.778L7.5 4.717v-1.51L6.147 1.854a.5.5 0 1 1 .707-.708l.646.647V.5a.5.5 0 0 1 1 0v1.293l.647-.647a.5.5 0 1 1 .707.708L8.5 3.207v1.51l2.053 1.232 1.348-.778.495-1.85a.5.5 0 1 1 .966.26l-.236.882 1.12-.646a.5.5 0 0 1 .5.866l-1.12.646.883.237a.5.5 0 1 1-.26.966l-1.848-.495-1.4.808v2.31l1.4.808 1.849-.495a.5.5 0 1 1 .259.966l-.883.237 1.12.646a.5.5 0 0 1-.5.866l-1.12-.646.236.883a.5.5 0 1 1-.966.258l-.495-1.849-1.348-.778L8.5 11.283v1.51l1.354 1.353a.5.5 0 0 1-.707.708l-.647-.647V15.5a.5.5 0 0 1-.5.5m2-6.783V6.783l-2-1.2-2 1.2v2.434l2 1.2z" />
                    </svg>
                    AC Compressor
                  </NavLink>
                </li>

                <li className="menuItemStyle" style={dir === "rtl" ? { float: "right", marginRight: "20px" } : { float: "left" }} >
                  <NavLink to="/Spare-Parts/Spare-Parts-nocar/100355/Condenser" style={{ color: "#bfcbd2" }} >

                    <svg style={{ fontSize: "16px", marginRight: dir === 'rtl' ? '0' : '7px', marginLeft: dir === 'rtl' ? '7px' : '0', verticalAlign: 'middle', marginTop: '-5px' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-layers-fill" viewBox="0 0 16 16">
                      <path d="M7.765 1.559a.5.5 0 0 1 .47 0l7.5 4a.5.5 0 0 1 0 .882l-7.5 4a.5.5 0 0 1-.47 0l-7.5-4a.5.5 0 0 1 0-.882z" />
                      <path d="m2.125 8.567-1.86.992a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882l-1.86-.992-5.17 2.756a1.5 1.5 0 0 1-1.41 0z" />
                    </svg>
                    Condenser
                  </NavLink>
                </li>

                {/* <li
                  className="menuItemStyle"
                  style={{ float: "left" }}
                >
                  <NavLink
                    to="/Spare-Parts/OilsLubes"
                    style={{ color: "rgb(191, 203, 210)" }}
                  >
                    <svg
                      className="header-nav__icon base-svg"
                      role="img"
                      style={{
                        width: "25px",
                        height: "25px",
                        marginTop: "-2px",
                        fill: "rgb(208, 213, 215)",

                        marginRight: "7px"
                      }}
                    >
                      <use href="/assets/images/icon-sprite-bw.svg#sprite-oil-icon-bw" />
                    </svg>

                    Oil & Lubes
                  </NavLink>
                </li>

                <li
                  className="menuItemStyle"
                  style={{ float: "left" }}
                >
                  <NavLink
                    to="/Spare-Parts/Batteries"
                    style={{ color: "rgb(191, 203, 210)" }}
                  >
                    <svg
                      className="header-nav__icon base-svg"
                      role="img"
                      style={{
                        width: "25px",
                        height: "25px",
                        marginTop: "-2px",
                        fill: "rgb(208, 213, 215)",

                        marginRight: "7px"
                      }}
                    >
                      <use href="/assets/images/icon-sprite-bw.svg#sprite-electrik-icon-bw" />
                    </svg>

                    Batteries
                  </NavLink>
                </li> */}

                {/* <li
                  className="menuItemStyle"
                  style={{ float: "left" }}
                >
                  <NavLink
                    to="/Spare-Parts/Wipers"
                    style={{
                      color: "rgb(191, 203, 210)",
                      display: "flex",
                      alignItems: "center"
                    }}
                  >

                    <svg
                      className="header-nav__icon base-svg"
                      role="img"
                      aria-label="Wiper"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        width: "25px",
                        height: "25px",
                        marginTop: "-2px",
                        marginRight: "7px",
                        fill: "none",
                        stroke: "rgb(208, 213, 215)",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        flexShrink: 0
                      }}
                    >
                      <path d="M3 15.5L19.5 7" />

                      <path d="M5 15.5L7 19H21" />

                      <path d="M19.5 7L21 5.5" />

                      <path d="M5.5 14.2L7 17" />
                      <path d="M8.5 12.7L10 15.5" />
                      <path d="M11.5 11.2L13 14" />
                      <path d="M14.5 9.7L16 12.5" />
                    </svg>

                    Wipers

                  </NavLink>
                </li> */}

                <li className="menuItemStyle" style={{ float: "left" }}>
                  <NavLink
                    to="/Spare-Parts/Wipers"
                    className="wipers-nav-link"
                    style={{
                      color: "rgb(191, 203, 210)",
                      display: "flex",
                      alignItems: "center"
                    }}
                  >
                    <span className="wipers-new-badge">NEW</span>

                    <svg
                      className="header-nav__icon base-svg"
                      role="img"
                      aria-label="Wiper"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        width: "25px",
                        height: "25px",
                        marginTop: "-2px",
                        marginRight: "7px",
                        fill: "none",
                        stroke: "rgb(208, 213, 215)",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        flexShrink: 0
                      }}
                    >
                      <path d="M3 15.5L19.5 7" />
                      <path d="M5 15.5L7 19H21" />
                      <path d="M19.5 7L21 5.5" />
                      <path d="M5.5 14.2L7 17" />
                      <path d="M8.5 12.7L10 15.5" />
                      <path d="M11.5 11.2L13 14" />
                      <path d="M14.5 9.7L16 12.5" />
                    </svg>

                    Wipers
                  </NavLink>
                </li>


                <li
                  className="menuItemStyle"
                  style={
                    dir === "rtl"
                      ? { float: "right", marginRight: "20px" }
                      : { float: "left" }
                  }
                >
                  <NavLink
                    to="/MyAccount/Orders"
                    style={{ color: "#bfcbd2" }}
                  >
                    <i
                      className="fas fa-clipboard-list"
                      style={{
                        fontSize: "16px",
                        marginRight: dir === 'rtl' ? '0' : '7px',
                        marginLeft: dir === 'rtl' ? '7px' : '0',
                        verticalAlign: 'middle',
                        marginTop: '-5px'
                      }}
                    ></i>
                    Track My Orders
                  </NavLink>
                </li>

                <li
                  className="menuItemStyle"
                  style={
                    dir === "rtl"
                      ? { float: "right", marginRight: "20px" }
                      : { float: "left" }
                  }
                >
                  <NavLink
                    to="/MyAccount/Favourites"
                    style={{ color: "#bfcbd2", position: "relative", display: "inline-flex", alignItems: "center" }}
                  >
                    <span style={{ position: "relative", display: "inline-block" }}>
                      <i
                        className="fas fa-heart"
                        style={{
                          fontSize: "16px",
                          marginRight: dir === 'rtl' ? '0' : '7px',
                          marginLeft: dir === 'rtl' ? '7px' : '0',
                          verticalAlign: 'middle',
                          marginTop: '-5px'
                        }}
                      ></i>

                      {/* Badge */}
                      {FavItemsQty > 0 && (
                        <span
                          style={{
                            position: "absolute",
                            top: "-6px",
                            left: "-8px",
                            background: "red",
                            color: "white",
                            borderRadius: "50%",
                            padding: "2px 5px",
                            fontSize: "10px",
                            fontWeight: "bold",
                            lineHeight: 1,
                            minWidth: "16px",
                            textAlign: "center"
                          }}
                        >
                          {FavItemsQty}
                        </span>
                      )}
                    </span>

                    Favourites
                  </NavLink>

                </li>

                {/* <li
                  className="menuItemStyle"
                  style={
                    dir === "rtl"
                      ? { float: "right", marginRight: "20px" }
                      : { float: "left" }
                  }
                >
                  <NavLink
                    to="/Spare-Parts/SpecialOffers"
                    style={{ color: "#bfcbd2" }}
                  >
                    <i
                      className="fas fa-star"
                      style={{
                        fontSize: "16px",
                        marginRight: dir === 'rtl' ? '0' : '7px',
                        marginLeft: dir === 'rtl' ? '7px' : '0',
                        verticalAlign: 'middle',
                        marginTop: '-5px'
                      }}
                    ></i>
                    Promotions & Deals
                  </NavLink>
                </li> */}

                {
                  currency.toLowerCase() !== "usd" &&
                  <li
                    className="menuItemStyle"
                    style={
                      dir === "rtl"
                        ? { float: "right", marginRight: "20px" }
                        : { float: "left" }
                    }
                  >
                    <NavLink
                      to="/MyAccount/RedeemPoints"
                      style={{ color: "#bfcbd2" }}
                    >
                      <span className="animated-bg" style={{ fontWeight: "bold" }}>
                        <i
                          className="fas fa-coins"
                          style={{
                            fontSize: "16px",
                            marginRight: dir === 'rtl' ? '0' : '7px',
                            marginLeft: dir === 'rtl' ? '7px' : '0',
                            verticalAlign: 'middle',
                            marginTop: '-5px'
                          }}
                        ></i>
                        Redeem Points
                      </span>
                    </NavLink>
                  </li>
                }

              </ul>
            </nav>
            <button className="btn btn-primary btn-sm mr-2" >
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setShowTrainingModal(true);
                }}
                style={{
                  color: "#bfcbd2"
                }}
              >
                <i className="fas fa-play" style={{
                  fontSize: "16px",
                  marginRight: dir === 'rtl' ? '0' : '7px',
                  marginLeft: dir === 'rtl' ? '7px' : '0',
                  verticalAlign: 'middle',
                  marginTop: '-5px',
                }}></i>
                Train Your Self
              </a>
            </button>
          </div>
          {/* End .container */}
        </div>

        {/* End .header-bottom */}
        {showTrainingModal && (
          <>
            {/* Backdrop */}
            <div
              className="modal-backdrop fade show"
              onClick={() => setShowTrainingModal(false)}
              style={{
                backgroundColor: 'rgba(0,0,0,0.5)',
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 9999999998,
              }}
            />

            {/* Modal */}
            <div
              className="modal fade show"
              style={{
                display: 'block',
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 9999999999,
                overflowY: 'auto',
              }}
            >
              <div
                className="modal-dialog modal-lg"
                style={{ margin: '5% auto' }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Training Video</h5>
                    <button
                      type="button"
                      className="close"
                      onClick={() => setShowTrainingModal(false)}
                      style={{
                        background: 'none',
                        border: 'none',
                        fontSize: '1.5rem',
                        cursor: 'pointer',
                        padding: '1rem',
                      }}
                    >
                      <span>&times;</span>
                    </button>
                  </div>
                  <div className="modal-body p-0">
                    <div className="embed-responsive embed-responsive-16by9">
                      <iframe
                        src={`${Config.country === "uae" ? "https://www.youtube.com/embed/K2WF6Qsn_q8?autoplay=1" : Config.country === "ksa" ? "https://www.youtube.com/embed/GqzTseUQrHc?autoplay=1" : "https://www.youtube.com/embed/K2WF6Qsn_q8?autoplay=1"}`}
                        title="Training Video"
                        allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

      </header >
    </>

  );
};

export default Header;
